// extracted by mini-css-extract-plugin
export default {"card":"DashboardSkeleton_card__g2AaD","dashboardCardShimmer":"DashboardSkeleton_dashboardCardShimmer__1ZZRW","page":"DashboardSkeleton_page__qMOM-"};